// src/components/ProtectedRoute/Admin/Consoles/Plugins/countries.plugin.js
import { Chip } from "@mui/material";

const statusColor = {
  canonical: "success",
  synonym: "default",
  historical: "warning",
  pending: "default",
};

const plugin = {
  table: "countries",
  select:
    "id,name,status,iso_a3,parent_id,period_from,period_to,note,created_at,updated_at,parent:parent_id(id,name,status)",
  defaultSort: { field: "name", sort: "asc" },
  or(search) {
    if (!search) return undefined;
    const like = `%${search}%`;
    return `or=(name.ilike.${like},iso_a3.ilike.${like})`;
  },
  normalize(row) {
    return {
      ...row,
      parent_name: row?.parent?.name || "",
    };
  },
  columns() {
    return [
      { field: "name", headerName: "Name", flex: 1, minWidth: 180 },
      {
        field: "status",
        headerName: "Status",
        width: 120,
        renderCell: (p) => (
          <Chip
            size="small"
            label={p.row.status || "pending"}
            color={statusColor[p.row.status] || "default"}
            variant="outlined"
          />
        ),
      },
      { field: "parent_name", headerName: "Parent (canonical)", flex: 1, minWidth: 180 },
      { field: "iso_a3", headerName: "ISO A3", width: 100 },
      {
        field: "period",
        headerName: "Period",
        width: 160,
        valueGetter: (p) => {
          const row = p?.row || {};
          const from = row.period_from || "";
          const to = row.period_to || "";
          if (!from && !to) return "";
          return `${from || ""}${from || to ? " - " : ""}${to || ""}`;
        },
      },
      { field: "note", headerName: "Note", flex: 1, minWidth: 200 },
    ];
  },
};

export default plugin;
